export const routesTools = [
  {
    path: "/tools",
    name: "tools",
    component: () => import("@/views/tools/index.vue"),
    meta: {
      public: false,
      title: "tools.jsonToExcel",
    },
  },
  {
    path: "/tools/json-to-excel",
    name: "tools-json-to-excel",
    component: () => import("@/views/tools/json_to_excel/index.vue"),
    meta: {
      public: false,
      title: "tools.jsonToExcel",
    },
  },
]
